
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/strategy/km7",
      function () {
        return require("private-next-pages/strategy/km7.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/strategy/km7"])
      });
    }
  